type Props = {
  label: string
  text?: string | undefined
  array?: string[]
}

export const LineProject = ({ label, text, array }: Props) => {
  return (
    <div>
      <p className=" font-medium text-base text-grey-900">{label}</p>
      {text && <p className=" font-normal text-base text-grey-800">{text}</p>}
      {array && (
        <>
          {array.map((info: string, index) => (
            <p
              key={`${index}${info}`}
              className=" font-normal text-base text-grey-800"
            >
              {info}
            </p>
          ))}
        </>
      )}
    </div>
  )
}
